export default __webpack_public_path__ + "static/media/University.fa908f79.svg";